import React, { useEffect, useState } from "react";
import LoadingComp from "../LoadingComp";
import Utils from "../../utils/utils";
import { MdOutlineSignalCellularAlt } from "react-icons/md";
import { useToast } from "../ToastContext";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";
import ProjectSubmissionCard from "./PrjectSubmissionCard";
// import SubmissionCard from "./SubmissionCard";

const ProjectDetailsAndSubmissions = ({ props }) => {
  const { item } = props;
  const { Projects } = useAppLibs();
  const LEVEL = Projects.LEVEL;
  const SUBJECT = Projects.SUBJECT;
  var difficulty = LEVEL[item.level];
  const [submissions, setSubmissions] = useState([]);
  const showToast = useToast();
  const [loading, setLoading] = useState(true);
  const [project, setProjects] = useState(JSON.parse(JSON.stringify(item)));
  const [createdBy] = useState(item?.createdBy.split("+")[1]);

  const FetchSubmissions = async (projectId) => {
    try {
      const result = await Projects.getSubmissions(projectId);
      if (result.success) {
        const response = result.data;
        if (response) {
          setSubmissions((prev) => response);
          setLoading(false);
        }
      } else {
        setLoading(false);
        showToast(result.error, "error", true, 4000);
      }
    } catch (error) {
      showToast("Something went wrong " + error.message, "error", true, 4000);
      setLoading(false);
      showToast(error.message, "error", true, 3000);
    }
  };

  useEffect(() => {
    FetchSubmissions(item._id);
  }, []);

  return (
    <div>
      <div
        bkl="AssignmentDetails"
        className="min-h-full h-full overflow-x-hidden overflow-y-auto bg-white p-4 rounded-l-lg"
        style={{
          WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <div className="p-6 space-y-4 min-h-fit shadow rounded mb-4">
          <div className="bg-gray-50 p-3 mt-2">
            <h3 className="text-2xl font-semibold text-gray-700 truncate">
              {project.title}
            </h3>
          </div>
          <p className="text-gray-600 text-md">
            <span className="font-medium">Description : </span>
            {project.description}
          </p>
          {project.instruction && (
            <p className="text-gray-500 text-md italic">
              Instruction : {project.instruction}
            </p>
          )}
          {createdBy && (
            <div className="flex gap-4">
              <div
                className="flex items-center gap-1"
                key={"CreatedBy" + item._id}
              >
                <div
                  className={`h-6 w-6 text-sm rounded-full flex items-center justify-center overflow-hidden ${
                    createdBy ? Utils.getRandomBgColor() + " text-white" : ""
                  }`}
                >
                  {Utils.getUserAvatar(createdBy)}
                </div>
                <div className="font-normal text-md text-[#544D4F]">
                  {createdBy}
                </div>
              </div>
            </div>
          )}
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <MdOutlineSignalCellularAlt size={16} />
            <button
              disabled
              className={` px-2 py-1 shadow ${difficulty.text} ${difficulty.bg} rounded`}
            >
              {difficulty.name}
            </button>
          </div>
          {project?.maxMarks && (
            <button disabled className="text-blue-500">
              <span>{project.maxMarks} Marks</span>
            </button>
          )}
        </div>
        <div className="p-6 space-y-4 shadow rounded-lg bg-white mb-4">
          <div>
            <p className=" text-xl font-semibold">Documents</p>
            {project?.docs.map((doc, i) => (
              <button
                className="text-blue-500 underline"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open(doc.url, "_blank", "noopener,noreferrer");
                }}
              >
                {doc.name}
              </button>
            ))}
          </div>
        </div>

        <div className="">
          {submissions.length > 0 &&
            submissions.map((submission) => (
              <ProjectSubmissionCard
                props={{ submission, project, setSubmissions }}
              />
            ))}
        </div>
      </div>

      {loading && <LoadingComp message={"Submissions loading "} />}
      {!loading && submissions.length === 0 && (
        <LoadingComp message={"No submission found ! "} loaded={true} />
      )}
    </div>
  );
};

export default ProjectDetailsAndSubmissions;
